<template>
    <section class="section">
        <b-row>
            <b-col>
                <b-card title="Log importazioni">
                    <div class="d-flex mt-4">
                        <div class="d-flex align-items-center">
                            <label class="mb-0">Filtra per </label>
                            <b-form-select class="filter form-control" v-model="type" :options="options" />
                        </div>
                        <div class="d-flex align-items-center ml-4">
                            <label class="mb-0">Filtra per Nome file </label>
                            <input type="text" class="filter form-control" v-model="name"/>
                        </div>
                    </div>
                    <div class="mt-4">
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                                enabled: true,
                                mode: 'records',
                                perPage: 50,
                                position: 'bottom',
                                perPageDropdown: [50, 100, 200, 500],
                                dropdownAllowAll: true,
                                setCurrentPage: 1,
                                jumpFirstOrLast : true,
                                firstLabel : 'First Page',
                                lastLabel : 'Last Page',
                                nextLabel: 'next',
                                prevLabel: 'prev',
                                rowsPerPageLabel: 'Rows per page',
                                ofLabel: 'of',
                                pageLabel: 'page', // for 'pages' mode
                                allLabel: 'All',
                            }"
                        />       
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </section>
</template>

<script>

import api from '@/services/api';
import moment from 'moment';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: { VueGoodTable },
    name: "ImportLogs",
    data() {
        return {
            importLogs: [],
            copyImportLogs: [],
            type: null,
            name: null,
            options: [
                { value: null, text: "Selezionare un filtro" },
                { value: "BLACKBOX", text: "BLACKBOX" },
                { value: "DRIVE", text: "DRIVE" },
                { value: "GMAIL", text: "GMAIL" },
                { value: "E_DISTRIB", text: "E_DISTRIB" },
                { value: "UPLOAD", text: "UPLOAD" },
                { value: "PRECALC", text: "PRECALC" }
            ],  
            rows: null, 
            columns: [
                {
                    label: 'Data',
                    field: 'createdOn',
                },
                {
                    label: 'Tipo',
                    field: 'type',
                },
                {
                    label: 'Records',
                    field: 'records',
                },
                {
                    label: 'Nome File',
                    field: 'fileName',
                },
                {
                    label: 'Meta',
                    field: 'meta',
                },
            ],  
        }
    },
    created() {
        api().get('/customer/import-logs').then( data => {
            this.importLogs = data.data.data;
            for(let a = 0; a < this.importLogs.length; a++ ) {
                this.importLogs[a].records = Intl.NumberFormat().format(this.importLogs[a].records);
                this.importLogs[a].createdOn = this.formatDate(this.importLogs[a].createdOn);
            }
            this.rows = this.importLogs;
            this.copyImportLogs = this.importLogs;
        });
    },
    watch: {
        type() {
            this.filters();
        },
        name() {
            this.filters();
        }
    },

    methods: {
        filters() {
            this.rows = this.importLogs.filter(item => {
                if(this.type && item.type != this.type) {
                    return false;
                }

                if(this.name) {
                    if(! item.fileName) {
                        return false;
                    }
                    if(item.fileName.toLowerCase().indexOf(this.name.toLowerCase()) < 0) {
                        return false;
                    }
                }
                
                return true;
            });
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        }
    }
}
</script>

<style scoped>
    .filter {
        margin-left: 10px;
        width: 200px;
        display: inline-block;
    }
    .item {
        background-color: #f2f2f2;
    }
    .item2 {
        background-color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/ImportLogs.vue